<template>
 <page>

   <head-nav title="language.update_document">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

<scroll-page>
    <page-padding>
      <ui-textarea title="language.provide_description" v-bind:val="description" @input="(v)=>{description = v}"></ui-textarea>

      <button-action v-if="isMobile" v-on:click.native="choosePDF()" title="language.choose_pdf" ></button-action>
      
      <!-- desktop variant -->
      <button-file v-if="!isMobile" :multiple="false" accept="application/pdf" title="language.choose_pdf" @change="choosePDF"></button-file>
      

      
      <!-- the current document -->
      <div class="file-graphic" v-if="!file">
        <div class="file-icon"><font-awesome-icon   v-bind='{ icon:"file" }' /></div>
        <div>{{document.title}}</div>
      </div>

      <!-- the new document -->
      <div class="file-graphic" v-if="file">
        <div class="file-icon"><font-awesome-icon   v-bind='{ icon:"file" }' /></div>
        <div>{{file.name}}</div>
      </div>

      <divider title=""/>
     
      
      <button-activate :active="buttonActive" v-on:click.native="confirm()" :title="computeTitle"></button-activate>
     
     </page-padding>
</scroll-page>  
   </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page.vue';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import ButtonFile from '../components/buttons/ButtonFile.vue';
import PagePadding from '../components/PagePadding.vue';
import ScrollPage from '../components/ScrollPage.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import UiTextarea from '../components/UiTextarea.vue';
import { modalService } from '../services/ModalService.js';
import i18n from "../language.js";
import Vue from 'vue';
import { history } from "../services/History.js";
import Divider from '../components/dividers/Divider.vue';
import { fileTransfer } from '../services/FileTransfer.js';
import { api } from '../services/Api';
import { cordovaInit } from '../services/CordovaInit.js';

export default {
  name: 'update-document-item-page',
  data:function(){
    return{
      id:this.$route.params.id, /* document id */
      description:"",
      buttonActive:true,
      file:undefined,
      isMobile:cordovaInit.isMobile(),
      document:{},
    }
  },
  computed:{
     ...mapState([
       'user_schools','appSettings',
       ]),
       computeTitle(){
        if(!this.buttonActive){
          return this.$t('language.working');
        }else{
           return this.$t('language.update_document');
        }
      },
      upload_path:function(){
        var school=this.user_schools.find(school => school.active === 1);
        return api.getUrl(school,"update_pdf.php");
      },
  },
  components: {
    ButtonActivate,
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    UiTextarea,
    Page,
    ScrollPage,
    ButtonAction,
    ButtonFile,
    Divider,
  },
  methods:{
    choosePDF(e){
     
      
      this.file={
        data:e.target.files[0].__proto__.arrayBuffer, // aka the blob type of file
        name:e.target.files[0].name, // create random bogus name
      }

    },
    back(){
      this.$router.push(history.get());
    },
    isFormComplete(){
      
      if(this.file===undefined){
          modalService.createAlert(i18n.t('language.form_incomplete_file'))

        return false;
      }

      return true
    },
    
    clearForm(){
      this.file=undefined;
      this.description="";

      // we done here lets go back
      this.back();
    }, 
   
    confirm(){
    
      //if(!this.isFormComplete()){
      //  return;
      //}

     this.buttonActive=false;
     setTimeout(()=>{
       this.callApi();
      },500);

    },
    callApi(){

      
      if(this.file){
        var loader=modalService.createLoader(i18n.t("language.uploading_file"))
      }

      
      var params={
        token:this.appSettings.token,
        id:this.id,
        description:this.description,
        file_name:this.file ? this.file.name : "no-file",
      }


      // get uint8array to make blob or pass empty blob.
      var blob = this.file ? new Blob([this.file.data], {type:'application/pdf'}) : new Blob();
      

      // upload blob, overzetten naar add_pdf
    setTimeout(()=>{

        fileTransfer.httpRequest(this.upload_path,blob,params).then(()=>{
          
          // TODO: resultaat nog bekijken ivm dubbele file upload...
          
          this.buttonActive=true;
          
          if(loader){
            loader.close();
          }
          
          this.clearForm();

          Vue.$toaster.toast("language.upload_file_complete");

        },(error)=>{
          Vue.$toaster.toast("language.upload_file_error"+error);
          this.buttonActive=true;
          loader.close();
        })

    },1000)
      

    },

    loadDocumentItem(){
      // load calendar item
      var payload={id:this.id}
     
      this.$store.dispatch('get_document_item',payload).then(result=>{

        
        this.description=result.data.descr
        this.file={
          name:result.data.filename
        }
        /*
        this.title=this.calendar_item.title;
        this.description=this.calendar_item.description;
        this.date=this.convert_date_us();
        this.timeFrom=this.calendar_item.start_time;
        this.timeTo=this.calendar_item.end_time;
        */
      })
    },
    
  },
  mounted(){

    this.loadDocumentItem();
   
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.file-graphic{
  margin-top:10px;
  display:inline-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.file-icon{
  font-size:2.5em;
}
</style>
